import { useThemeStore } from "@stores/theme.store";
import moment from "moment-timezone";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
moment.locale("id");
export const TahfidzDetailPage = () => {
  const { state } = useLocation();
  const { setHeader, setAppBar } = useThemeStore((state) => state);

  useEffect(() => {
    setAppBar({ title: "Detail Tahfidz", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Detail Tahfidz",
    });
  }, [setHeader, setAppBar]);

  return (
    <>
      <div className="tw-px-4 tw-pb-20">
        <div className="tw-bg-other-100 tw-rounded-lg card-body">
          <div className="tw-text-primary-hg tw-text-xs">Bulan</div>
          <div className="tw-mb-3">
            {moment(state.bulan ?? Date.now()).format("MMMM YYYY")}, pekan
            {state.pekan ?? "-"}
          </div>

          <div className="tw-text-primary-hg tw-text-xs">Surat</div>
          <div className="tw-mb-3">{state.surat ?? "-"}</div>

          <div className="tw-text-primary-hg tw-text-xs">Ayat Awal - Akhir</div>
          <div className="tw-mb-3">
            {state.ayatAwal ?? "0"} - {state.ayatAkhir ?? "0"}
          </div>

          <div className="tw-text-primary-hg tw-text-xs">Total Halaman</div>
          <div className="tw-mb-3">{state.halaman ?? "-"}</div>

          <div className="tw-text-primary-hg tw-text-xs">Keterangan</div>
          <div className="tw-mb-3">{state.keterangan ?? "-"}</div>
        </div>
      </div>
    </>
  );
};
